import { Component, Vue, PropSync, Emit } from 'vue-property-decorator';

@Component
export default class TitleButtonComponent extends Vue {
    @PropSync('title', { type: String }) public syncedTitle!: string;
    @PropSync('text', { type: String }) public syncedText!: string;
    @PropSync('icon', { type: String }) public syncedIcon!: string;
    @PropSync('floating', { type: Boolean }) public syncedfloating!: boolean;
    @PropSync('disabled', { type: Boolean }) public syncedDisabled!: boolean;

    public demoVar: boolean = true;

    // tslint:disable-next-line: no-empty
    public mounted() {

    }

    @Emit()
    public onButtonPressed(event: Event) {
        return event;
    }

    public onClick(event: Event) {
        this.onButtonPressed(event);
    }
}
